import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InternalLoginPage } from './page/internal-login.page';
import { SharedModule } from '../_shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [InternalLoginPage],
  imports: [CommonModule, SharedModule, TranslateModule, ReactiveFormsModule],
  exports: [InternalLoginPage],
})
export class InternalLoginModule {}
